// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { AllocationRequest } from '@daml.js/splice-api-token-allocation-request/lib/Splice/Api/Token/AllocationRequestV1';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import InterfaceContract from '../../../../utils/InterfaceContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

const useAllocationRequests: () => UseQueryResult<
  InterfaceContract<AllocationRequest>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOptions({
    queryKey: ['queryAllocationRequest'],
    queryFn: async (_, options) => {
      return ledgerApi.queryAllocationRequestInterface(options);
    },
  });
};

export default useAllocationRequests;
